import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import { url } from '../../../constants/routes';
import { connect } from '../../../reducers/index';
import './styles.css';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';
import SingleSelectQuestions from '../../../components/Questions/SingleSelectQuestions';
import UnClickableScreenReader from '../../../components/ScreenReader/UnClickableScreenReader';
//import AssistGraphic from '../img/assist-graphic.svg';
// import AssistGraphic02 from '../img/assist-prof-holding-map-graphic.svg';

const AssistPage = props => {
  const questions = {
    //title: 'Question 5e: Strategies',
    type: 'single',
    text: (
      <Fragment>
        <UnClickableScreenReader
          text={`Personal Reflection: How do you feel when using this component when trying to assist someone?`}
        />
        <strong>
        Personal Reflection: How do you feel when using this component when trying to assist someone? 
        </strong>
      </Fragment>
    ),
    result: [],
    feedback: {
      correct: '',
      incorrect: '',
      all: ''
    }
  };
  const options = [
    {
      prefix: 'A',
      result: '',
      optionText:
        'I have to be really focused and intentional when doing this.'
    },
    {
      prefix: 'B',
      result: '',
      optionText:
        'I am often able to do this but it’s a good reminder.'
    },
    {
      prefix: 'C',
      result: '',
      optionText:
        'I always do this.'
    }
  ];
  return (
    <EducationModuleLayout
      progressStage={7}
      childTitle="Assist"
      progressType="assist"
    >
      <section className="no-bottom-padding">
        <div className="container">
          <Row className="text-center">
            <Col xs={10} xsOffset={1}>
              <UnClickableScreenReader text="5. Avoid giving advice" />
              <h2 className="txt-green no-bold no-margin">
                5. Avoid giving advice
              </h2>
            </Col>
          </Row>
        </div>
      </section>
      <section className="no-bottom-padding">
        <div className="container">
          <Row>
            <Col xs={10} xsOffset={1}>
              <UnClickableScreenReader text="Resist the temptation to give advice or “fix” what you perceive to be the problem. " />
              <p>Resist the temptation to give advice or “fix” what you perceive to be the problem.</p>
              <p>Reasons to avoid giving advice include:</p>
              <ul className="list-group">
                <li className="list-group-item">
                  Advice may not be welcomed
                </li>
                <li className="list-group-item">
                  You may cause them to feel unsupported
                </li>
                <li className="list-group-item">
                  You may prevent them from expressing the real issue
                </li>
                <li className="list-group-item">
                  You may give wrong advice
                </li>
              </ul>
              <p>Instead of giving advice, facilitate a connection to preferred resources. We will explore this step in the Refer section.</p>
            </Col>
          </Row>
        </div>
      </section>

      <SingleSelectQuestions
        questions={questions}
        options={options}
        questionType="assist"
        categoary="survey"
        showLetter={false}
        nextRoute={url.ASSIST_H}
        previousRoute={() => props.history.goBack()}
      />
    </EducationModuleLayout>
  );
};

AssistPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const AssistG = connect.role(AssistPage);

export default AssistG;



// WEBPACK FOOTER //
// ./src/containers/Assist/AssistG/index.jsx